export default __webpack_public_path__ + "static/media/start_posture.bf11310a.png";